export const C1_COLORS = [null, 'cool-gray', 'gray', 'green', 'yellow', 'red', 'blue', 'primary', 'secondary', 'warning'];
export const C1_SHADOWS = [null, 'md', 'lg', 'xl', '2xl', 'inner', 'outline', 'none'];
export const C1_TAG_VARIANTS = [null, 'solid', 'outline'];
export const C1_CALLOUTS = [null, 'info', 'warning', 'danger'];
export const C1_SELECTOR = [null, 'radio', 'plus'];
